import React, { MouseEventHandler, FocusEventHandler, KeyboardEventHandler } from "react";
import { isEmpty } from "../../js/common";

// assets
import errorIcon from "bodycodi/cmap/app/img/error-1010.png";
import removeIcon from "bodycodi/cmap/app/img/remove.png";

type NameInputProps = {
  name?: string;
  placeholder: string;
  label: string;
  value?: string;
  errorMsg?: string;
  onChange?: any;
  onClick?: MouseEventHandler<HTMLInputElement> | undefined;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
};

const NameInput = ({
  name,
  placeholder,
  label,
  value,
  onChange,
  onBlur,
  errorMsg,
}: NameInputProps) => {
  const handleOnInput = (e: any) => {
    e.target.value = e.target.value.trim().substring(0, 20);
    onChange(e.target.value);
  };

  return (
    <div className="name-container">
      <div className="label">{label}</div>

      <div className={"input-box-wrap" + (!isEmpty(errorMsg) ? " error" : "")}>
        <div className="input">
          <input
            type="text"
            name={name}
            placeholder={placeholder}
            value={value}
            onInput={handleOnInput}
            onBlur={onBlur}
          />
        </div>
        {!isEmpty(value) && (
          <img
            className="remove"
            src={removeIcon}
            onClick={() => {
              onChange("");
            }}
          />
        )}
      </div>

      <div className="helper-texts">
        <div className={"message-wrap" + (!isEmpty(errorMsg) ? " active" : "")}>
          <div className="error-message">
            <img src={errorIcon} />
            <span>{errorMsg}</span>
          </div>
        </div>

        <div className="text-len">
          <span>
            <span>{value?.length}</span>/20
          </span>
        </div>
      </div>
    </div>
  );
};

export default NameInput;
